import axios from "axios";
import apisConfig from "../config/apis";

const { hosts } = apisConfig.urls;

export async function notifyIssue(payload) {
  if (
    !payload ||
    Object.keys(payload).length === 0 ||
    process.env.NODE_ENV === "development"
  )
    return;
  try {
    const response = await axios.post(
      `${hosts.mainApiUrl}/api/notifyIssue`,
      JSON.stringify({
        ...payload,
        additionalData: {
          href: window.location.href,
        },
      }),
      {
        headers: {
          "Content-Type": "text/plain",
        },
      }
    );
    // eslint-disable-next-line no-console
    console.log("Error reported", response.data);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Error:", error.message);
  }
}
